import * as actionTypes from 'constants/ActionTypes';

export function getVessels(pagination) {
    return {
        type: actionTypes.GET_VESSELS.REQUEST,
        pagination,
    };
}

export function deleteNameSuggestion({ vessel, refreshVessel, suggestedName }) {
    return {
        type: actionTypes.DELETE_NAME_SUGGESTION.REQUEST,
        vessel,
        refreshVessel,
        suggestedName,
    };
}

export function renameVessel(vessel, refreshVessel) {
    return {
        type: actionTypes.RENAME_VESSEL.REQUEST,
        vessel,
        refreshVessel,
    };
}

export function confirmVessel(id) {
    return {
        type: actionTypes.CONFIRM_VESSEL.REQUEST,
        id,
    };
}

export function getVessel(id) {
    return {
        type: actionTypes.GET_VESSEL.REQUEST,
        id,
    };
}

export function updateVessel(vessel) {
    return {
        type: actionTypes.UPDATE_VESSEL.REQUEST,
        vessel,
    };
}

export function deleteVessel(vessel, reason) {
    return {
        type: actionTypes.DELETE_VESSEL.REQUEST,
        vessel,
        reason,
    };
}

export function addVessel(vessel) {
    return {
        type: actionTypes.ADD_VESSEL.REQUEST,
        vessel,
    };
}

export function saveVessel(vessel) {
    return {
        type: actionTypes.SAVE_VESSEL,
        vessel,
    };
}

export function clearVessel() {
    return {
        type: actionTypes.CLEAR_VESSEL,
    };
}

export function updateVesselImage(vesselId, images) {
    return {
        type: actionTypes.UPDATE_VESSEL_IMAGE.REQUEST,
        vesselId,
        images,
    };
}

export function patchVesselFields(vesselId, fields) {
    return {
        type: actionTypes.PATCH_VESSEL_FIELDS.REQUEST,
        vesselId,
        fields,
    };
}



// WEBPACK FOOTER //
// ./app/actions/vessels/vessels.js